<template>
  <div class="c-content-block-cta">
    <sc-text tag="h3" v-if="fields && fields.heading" :field="fields.heading" />
    <sc-rich-text v-if="fields && fields.content" :field="fields.content" />
    <p
      v-if="
        fields &&
        fields.secondaryCta &&
        fields.secondaryCta.value &&
        fields.secondaryCta.value.text &&
        fields.secondaryCta.value.text.length > 0
      "
    >
      <sc-link
        v-if="fields && fields.secondaryCta && fields.secondaryCta.value"
        :field="fields.secondaryCta"
        class="c-cta--secondary"
        :class="fields.secondaryCta.value.class"
      />
    </p>
    <p
      v-if="
        fields &&
        fields.tertiaryCta &&
        fields.tertiaryCta.value &&
        fields.tertiaryCta.value.text &&
        fields.tertiaryCta.value.text.length > 0
      "
    >
      <sc-link
        v-if="fields && fields.tertiaryCta && fields.tertiaryCta.value"
        :field="fields.tertiaryCta"
        class="c-cta--tertiary"
        :class="fields.tertiaryCta.value.class"
      />
    </p>
  </div>
</template>

<script>
import { Text, RichText, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Content-Block-With-CTA',
  components: {
    ScText: Text,
    ScRichText: RichText,
    ScLink: Link
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.c-content-block-cta {
  &:deep() {
    a[class^='c-cta'] {
      margin-bottom: 0;
    }

    a.c-cta--tertiary {
      padding-left: 0;
    }
  }
}
</style>
